<template >
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>

    <h2>{{ $t("workflow.processEdit") }}</h2>

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>

    <b-row>
      <b-col>
        <process-crud :model="model" :modelstate="modelstate"></process-crud>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col>
        <b-button size="md" @click="saveProcess" :disabled="submitted">
          {{ $t("workflow.processSave") }}
        </b-button>
      </b-col>
    </b-row>

    <!-- <pre class="language-json"><code>model: {{ model  }}</code></pre> -->
    <!-- <pre class="language-json"><code>modelstate: {{ modelstate  }}</code></pre> -->
  </b-container>
</template>
<script>
export default {
  name: "ProcessEdit",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    ProcessCrud: () =>
      import("@/components_rms/workflow/Process/ProcessCrud.vue"),
  },
  props: {
    id: String,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "Processo editado com sucesso",
      },
      model: {},
      modelstate: {},
      submitted: false,
    };
  },
  created() {
    this.loadProcess();
  },
  computed: {
    getUrlBackToList() {
      return `/workflow/processList`;
    },
  },
  methods: {
    loadProcess() {
      this.$apiWorkflow
        .get("/process/getById/" + this.id)
        .then((response) => {
          this.model = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              } else {
                this.modelstate = {};
              }
              if (error.response.data && error.response.data.detail) {
                this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data.detail}`;
                this.$refs.danger.show();
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                this.$refs.danger.show();
              }
            } else {
              this.modelstate = {};
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
    },
    saveProcess() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/process/Edit", this.model)
        .then((response) => {
          this.submitted = false;
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.submitted = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>